import React, { useState } from "react";
import { Container, Box, Typography, TextField, Button, Alert } from "@mui/material";
import { updatePassword } from "firebase/auth";
import { useAuth } from "../../context/AuthContext";
import { auth } from "../../firebase/firebaseConfig";

const ChangePasswordPage = () => {
  const { user } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage({ type: "error", text: "Las contraseñas no coinciden." });
      return;
    }

    try {
      await updatePassword(auth.currentUser, newPassword);
      setMessage({ type: "success", text: "Contraseña actualizada correctamente." });
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("❌ Error al actualizar contraseña:", error);
      setMessage({ type: "error", text: "Error al actualizar contraseña. Intenta nuevamente." });
    }
  };

  if (!user) {
    return (
      <Container>
        <Typography mt={5} align="center">Debe iniciar sesión para cambiar su contraseña.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box mt={5}>
        <Typography variant="h5" gutterBottom>
          Cambiar Contraseña
        </Typography>
        <Typography variant="body1" gutterBottom>
          Usuario actual: <strong>{user.email}</strong>
        </Typography>
        <form onSubmit={handleChangePassword}>
          <TextField
            label="Nueva contraseña"
            type="password"
            fullWidth
            margin="normal"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            label="Confirmar nueva contraseña"
            type="password"
            fullWidth
            margin="normal"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {message.text && (
            <Alert severity={message.type} sx={{ mt: 2 }}>
              {message.text}
            </Alert>
          )}
          <Button variant="contained" type="submit" fullWidth sx={{ mt: 2 }}>
            Guardar nueva contraseña
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default ChangePasswordPage;